import SectionHeading from "./SectionHeading";
import { classicAnime } from "@/mocks/anime";

export default function ClassicSection() {
  return (
    <section id="classic" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="值得重看的老番"
        title="经典老番补番区"
        desc="这些作品完结多年仍有稳定口碑，剧情完整、无需追更，适合安排在周末整段时间一口气看完。同一题材的不同年代作品也在收集中。"
      />

      <div className="mt-8 flex flex-col gap-4">
        {classicAnime.map((item) => (
          <article
            key={item.id}
            className="group grid grid-cols-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-accent-300 sm:grid-cols-[150px_1fr] md:p-4"
          >
            <div className="relative h-[200px] w-full overflow-hidden rounded-md bg-background-100 sm:h-[200px]">
              <img
                src={item.cover}
                alt={`《${item.title}》经典老番封面`}
                title={`${item.title} | 51动漫经典补番`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-accent-950">
                {item.year} 年
              </span>
            </div>

            <div className="flex flex-col">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <h3 className="font-heading text-2xl text-foreground-950">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 font-bold text-primary-600">
                    <i className="ri-star-fill text-[10px]" />
                    {item.score.toFixed(1)}
                  </span>
                  <span>全 {item.episodes} 集</span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                    {item.status}
                  </span>
                </div>
              </div>
              <p className="mt-1 text-xs text-foreground-500">
                {item.subtitle} · {item.genre}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

              <div className="mt-auto flex flex-wrap items-center gap-2 pt-4">
                <span className="inline-flex items-center gap-1.5 rounded-md bg-primary-50 px-3 py-1.5 text-xs text-primary-700">
                  <i className="ri-play-circle-line" />
                  在线观看入口
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
                  <i className="ri-download-2-line" />
                  1080P 下载
                </span>
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-background-200 px-2.5 py-1 text-[11px] text-foreground-500"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}